import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
  size?: 'md' | 'lg';
};
export function CTAButton({
  label,
  note,
  id,
  size = 'lg'
}: CTAButtonProps) {
  return <div className="w-full" data-id="element-126" data-mp="2fzl9pcll48wv">
      <a id={id} href={CHECKOUT_URL} className={['group flex w-full items-center justify-center gap-2 rounded-2xl bg-gogreen-500 text-center font-extrabold uppercase tracking-wide text-white shadow-cta', 'transition-[transform,background-color] duration-150 ease-out hover:bg-gogreen-600 active:scale-[0.985]', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gogreen-700', size === 'lg' ? 'px-5 py-4 text-[15px] leading-tight sm:text-lg sm:py-5' : 'px-4 py-3.5 text-[13px] leading-tight sm:text-base'].join(' ')} data-id="element-127" data-mp="2fzbqc7v1p005">
        <span className="text-balance" data-id="element-128" data-mp="19968orf67f7n">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-129" data-mp="19ahdmukcqt0c" />
      </a>
      {note ? <p className="mt-3 text-center text-[12.5px] font-medium leading-snug text-brand-800/70 sm:text-sm" data-id="element-130" data-mp="1i804ifkog1k5">
          {note}
        </p> : null}
    </div>;
}